import { useEffect } from 'react';

export const useCallbackOnOutsideClick = (ref, cb) => {
  // eslint-disable-next-line
  const handleOutsideClick = (e) => {
    if (
      ref.current &&
      !ref.current.contains(e.target) &&
      e.target.className &&
      !String(e.target.className).includes('Select')
    ) {
      cb();
    }
  };

  // TODO: Fix dependency array
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []); // eslint-disable-line
};
